import { useRef } from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey.js';
import { useFocusTrap } from '../hooks/useFocusTrap.js';

export function KeyboardHelpModal({ open, onClose }) {
  const ref = useRef(null);
  useEscapeKey(onClose, open);
  useFocusTrap(ref, open);

  if (!open) return null;
  return (
    <div
      className="a11y-modal__backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={ref}
        className="a11y-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="a11y-help-title"
      >
        <h2 id="a11y-help-title">Keyboard shortcuts</h2>
        <ul>
          <li><span>Skip to main content</span><kbd>Alt + 1</kbd></li>
          <li><span>Open / close accessibility panel</span><kbd>Alt + S</kbd></li>
          <li><span>Show this help</span><kbd>Alt + H</kbd></li>
          <li><span>Toggle focus highlight</span><kbd>Alt + F</kbd></li>
          <li><span>Pause / resume animations</span><kbd>Alt + P</kbd></li>
          <li><span>Increase text size</span><kbd>Alt + +</kbd></li>
          <li><span>Decrease text size</span><kbd>Alt + -</kbd></li>
          <li><span>Reset text size</span><kbd>Alt + 0</kbd></li>
          <li><span>Reset all accessibility settings</span><kbd>Alt + R</kbd></li>
        </ul>
        <button type="button" className="a11y-modal__close" onClick={onClose}>
          Close (Esc)
        </button>
      </div>
    </div>
  );
}

export default KeyboardHelpModal;
